import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { Star } from 'react-feather';
import RatingOptionButton from '../../common/rating-option-button';
import { STAR_SCORES } from '../../constants/feedback-constants';

const renderStarIcon = () => <Star size={28} />;

// Hovering previews the score; stars up to the active score are highlighted.
const StarRating = ({ value, onChange }) => {
  const [hovered, setHovered] = useState(null);
  const active = hovered ?? value ?? 0;
  const handleMouseLeave = useCallback(() => setHovered(null), []);

  return (
    <div className="flex gap-1.5" onMouseLeave={handleMouseLeave}>
      {STAR_SCORES.map((score) => (
        <RatingOptionButton
          key={score}
          score={score}
          renderIcon={renderStarIcon}
          highlighted={score <= active}
          className="feedback-icon-option feedback-star-option"
          onSelect={onChange}
          onHover={setHovered}
        />
      ))}
    </div>
  );
};

StarRating.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

StarRating.defaultProps = {
  value: null,
};

export default StarRating;
